export default __webpack_public_path__ + "static/media/Slide2.69ff706a.svg";